<template>
  <ToggleGroupRoot
    v-model="internalState"
    :type="type"
    aria-label="Priorities"
    asChild
  >
    <ScrollableList>
      <template #items>
        <ToggleGroupItem
          as="div"
          v-for="priority in priorities"
          :key="priority.id"
          class="flex items-center justify-between border rounded-md gap-3 py-3 px-4 hover:cursor-pointer transition-all select-none data-[state=off]:bg-white data-[state=off]:hover:bg-gray-50 data-[state=on]:bg-[#E1EBF8] data-[state=on]:border-[#79AAE1] data-[state=on]:text-[#3b60ba]"
          :class="{
            'data-[state=off]:text-tertiary data-[state=on]:text-utility-gray-700 data-[state=off]:hover:bg-utility-gray-50 data-[state=off]:hover:border-utility-gray-300 data-[state=on]:bg-utility-gray-50 data-[state=on]:border-utility-gray-300':
              type === 'single' && priority.id === 'low',
            'data-[state=off]:text-tertiary data-[state=on]:text-utility-gray-700 data-[state=off]:hover:bg-utility-warning-50 data-[state=off]:hover:border-utility-warning-300 data-[state=on]:bg-utility-warning-50 data-[state=on]:border-utility-warning-300':
              type === 'single' && priority.id === 'normal',
            'data-[state=off]:text-tertiary data-[state=on]:text-utility-gray-700 data-[state=off]:hover:bg-utility-error-50 data-[state=off]:hover:border-utility-error-300 data-[state=on]:bg-utility-error-50 data-[state=on]:border-utility-error-300':
              type === 'single' && priority.id === 'high',
          }"
          :value="priority.id"
          :isChecked="isChecked(priority.id)"
          :showCheckbox="type === 'multiple'"
        >
          <template v-if="type === 'single'">
            <AlertCircle
              class="w-4 h-4"
              :class="{
                'text-utility-gray-500':
                  type === 'single' && priority.id === 'low',
                'text-utility-warning-500':
                  type === 'single' && priority.id === 'normal',
                'text-utility-error-600':
                  type === 'single' && priority.id === 'high',
              }"
            />
          </template>
          <span class="font-medium truncate">
            {{ priority.name }}
          </span>
        </ToggleGroupItem>
      </template>
    </ScrollableList>
  </ToggleGroupRoot>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { usePage } from "@inertiajs/vue3";
import { ToggleGroupRoot } from "radix-vue";
import { ScrollableList, ToggleGroupItem } from "@/Components/List";
import { AlertCircle } from "@/Icons";

const emit = defineEmits(["update:selected"]);

const props = defineProps({
  selected: { type: [String, Array], required: false },
  type: {
    type: String,
    validator: (val) => ["single", "multiple"].includes(val),
    required: true,
  },
});

const priorities = usePage().props.priorities;

const internalState = ref(props.selected);

watchEffect(() => {
  emit("update:selected", internalState.value);
});

function isChecked(priorityId) {
  if (props.type === "single") {
    return internalState.value === priorityId;
  }
  return internalState.value.includes(priorityId);
}
</script>
